import { useState, useEffect } from "react";
import useAdminDataStore, {
  selectCurrentGroupId,
  selectAllGroups,
} from "../../../store/adminData/adminData";
import useUserStore, { selectUserDetails } from "../../../store/user/user";
import LoadingModal from "../../commons/LoadingModal";
import Setup from "./Setup";
import Sections from "./Sections";
import About from "./About";
import CommunityPartners from "./CommunityPartners";
import { db } from "../../../services/firebaseService/connection";
import { Spin } from "antd";
import { getWebsiteConfig } from "../../../services/firebaseService/endPoints/admin/website";
import Leadership from "./Leadership";
import { doc, updateDoc } from "firebase/firestore";
import fakeDispatch from "../../../utils/fakeDispatch";
import { setGettingStartedItemStatus } from "../../../redux/actions/adminData";
import {
  GUIDE_GROW,
  TOPIC_PUBLISH_WEBSITE,
} from "../../../constants/gettingStarted";
import WebsiteMembership from "./WebsiteMembership";
import { withRouter } from "../../../utils/helper";
import TabNav from "../../../CommonComponents/TabNav/TabNav";
import WebsiteGallery from "./WebsiteGallery/WebsiteGallery";
import { postUpdateCDNUtil } from "../../../helperFunctions/util";
import OurChants from "./OurChants";
import ScreenHeader from "../../../CommonComponents/ScreenHeader";
import ChantButton from "../../../CommonComponents/ChantButton/ChantButton";

const Container = ({ router }) => {
  const currentGroup = useAdminDataStore(selectCurrentGroupId);
  const allGroups = useAdminDataStore(selectAllGroups);
  const adminData = allGroups[currentGroup];
  const user = useUserStore(selectUserDetails);

  const [isPublished, setIsPublished] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [tabLoading, setTabLoading] = useState(false);

  const fetchData = () => {
    getWebsiteConfig(currentGroup).then((data) => {
      setIsPublished(data.isPublished || false);
      if (data?.isPublished) {
        fakeDispatch(
          setGettingStartedItemStatus(
            currentGroup,
            GUIDE_GROW,
            TOPIC_PUBLISH_WEBSITE,
            true,
          ),
        );
      }
    });
  };

  useEffect(() => {
    fetchData();
  }, [currentGroup]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setTabLoading(true);
    const timer = setTimeout(() => setTabLoading(false), 200);
    return () => clearTimeout(timer);
  }, [router.params.tab]);

  const changePublish = () => {
    setUpdating(true);
    const docRef = doc(db, "website", currentGroup);
    const newIsPublished = !isPublished;
    updateDoc(docRef, { isPublished: newIsPublished }).then(() => {
      postUpdateCDNUtil(currentGroup);
      fetchData();
      setUpdating(false);
    });
  };

  let primaryColor = "";
  if (adminData?.data?.configuration?.primaryColor) {
    const { r, g, b } = adminData.data.configuration.primaryColor;
    primaryColor = `rgb(${r}, ${g}, ${b})`;
  }

  if (user.isAuthenticated === undefined) {
    return <LoadingModal />;
  }

  const websiteTabItems = [
    { key: "sections", label: "News & Events" },
    { key: "about", label: "About" },
    { key: "leadership", label: "Leadership" },
    { key: "membership", label: "Membership" },
    { key: "community", label: "Partners" },
    { key: "gallery", label: "Gallery" },
    { key: "our-chants", label: "Chants" },
  ];

  return (
    <div
      className="col"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <div style={{ padding: "16px 16px 0" }}>
        {router.params.tab === "general" ? (
          <Setup />
        ) : (
          <>
            <ScreenHeader
              title="Website"
              actions={
                <ChantButton
                  type={isPublished ? "secondary" : "primary"}
                  loading={updating}
                  onClick={changePublish}
                  style={
                    isPublished
                      ? {}
                      : {
                          backgroundColor: primaryColor,
                          borderColor: primaryColor,
                        }
                  }
                >
                  {isPublished ? "Unpublish" : "Publish"}
                </ChantButton>
              }
            />

            <div style={{ marginTop: "2px" }}>
              <TabNav
                items={websiteTabItems}
                activeKey={router.params.tab}
                handleTabChange={(key) =>
                  router.navigate(`/admin/website/${key}`, { replace: true })
                }
              />
            </div>

            <div style={{ minHeight: "200px" }}>
              {tabLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <>
                  {router.params.tab === "sections" && <Sections />}
                  {router.params.tab === "leadership" && <Leadership />}
                  {router.params.tab === "membership" && <WebsiteMembership />}
                  {router.params.tab === "about" && <About />}
                  {router.params.tab === "community" && <CommunityPartners />}
                  {router.params.tab === "gallery" && <WebsiteGallery />}
                  {router.params.tab === "our-chants" && <OurChants />}
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default withRouter(Container);
